import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { UnauthorizedService } from '../services/unauthorized.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const unauthorizedService = inject(UnauthorizedService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 403) {
        unauthorizedService.set();
      }
      return throwError(() => error);
    }),
  );
};
